import { css } from 'styled-components';
export const breakpoints = [36, 48, 62, 75].map(n => `${n}em`);
export const sizes = {
  lg: breakpoints[3],
  md: breakpoints[2],
  sm: breakpoints[1],
  xs: breakpoints[0]
};
export const media = Object.keys(sizes).reduce((acc, label) => {
  acc[label] = (literals, ...args) => css(["@media (min-width:", "){", ";}"], sizes[label], css(literals, ...args));

  return acc;
}, {});
export const space = [0, 4, 8, 12, 16, 20, 24, 32, 64, 128];
export const iconSizes = [16, 20, 24, 28, 32]; // font

export const font = 'HarmoniaSans, helvetica, Arial, sans-serif';
export const fontSecondary = 'sans-serif';
export const fontFamilies = [font, fontSecondary];
export const fontSizes = [12, 14, 16, 20, 22, 24, 32, 40, 52];
export const fontWeights = {
  regular: 400,
  semiBold: 500,
  bold: 600,
  black: 800
};
export const lineHeights = ['16px', '20px', '24px', '28px', '32px', '36px', '40px', '52px']; // colors
// primary

export const blue = '#08A6A5';
export const green = '#08B87D';
export const orange = '#FCBA62';
export const red = '#EB445A';
export const white = '#FFFFFF';
export const black = '#414245'; // light

export const lightBlue = '#DFF2F9';
export const lightGreen = '#DFFBF2';
export const lightOrange = '#FCF0E3';
export const lightRed = '#FFE3E0';
export const lightBlack = '#F7F7F4';
export const linkBlue = '#0391CC'; // gray

export const gray = ['#EBEBE8', '#C8CACC', '#B4B6B8', '#858688', '#5C5C5E']; // text

export const textColors = {
  black: 'rgba(65,66,69,1)',
  gray: 'rgba(65,66,69,0.60)',
  lightGray: 'rgba(65,66,69,0.38)'
}; // icon

export const iconColors = {
  active: '#414245',
  regular: '#858688',
  disabled: '#5C5C5E'
};
export const colors = {
  blue,
  green,
  orange,
  red,
  white,
  black,
  lightBlue,
  lightGreen,
  lightOrange,
  lightRed,
  lightBlack,
  gray,
  text: textColors,
  icons: iconColors,
  state: {
    primary: blue,
    primaryLight: lightBlue,
    success: green,
    successLight: lightGreen,
    warning: orange,
    warningLight: lightOrange,
    danger: red,
    dangerLight: lightRed
  },
  links: {
    blue: linkBlue
  }
}; // box
// no spacing in rgba vals because tests will fail. browser sets rule without space

export const shadows = ['0 1px 4px 0 rgba(21,37,66,0.18)', '0 4px 8px 0 rgba(21,37,66,0.15)', '0 6px 16px 0 rgba(21,37,66,0.15)', '0 16px 32px 0 rgba(21,37,66,0.15)'];
export const radii = [0, 2, 4, 14];
const theme = {
  breakpoints,
  colors,
  font,
  fontFamilies,
  fontSizes,
  fontWeights,
  iconSizes,
  lineHeights,
  radii,
  shadows,
  space
};
export default theme;